export default {"src":"https://fishbrain.com/_next/static/media/ic_weather_night_308.5f6545e3.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};